import { render, staticRenderFns } from "./OrderListRow.vue?vue&type=template&id=15806956&scoped=true&"
import script from "./OrderListRow.vue?vue&type=script&lang=js&"
export * from "./OrderListRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderListRow.vue?vue&type=style&index=0&id=15806956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15806956",
  null
  
)

export default component.exports